import React from 'react';
import AdminElectricalStylePricingEditor from './AdminElectricalStylePricingEditor';

const SERVICES = {
  500: { name: 'Bathroom Plumbing' },
  501: { name: 'Boiler Installation' },
  502: { name: 'Central Heating Installation' },
  503: { name: 'Emergency Plumbing' },
  504: { name: 'Gas Engineering' },
  505: { name: 'General Plumbing' },
  506: { name: 'Hot Water Cylinders' },
  507: { name: 'Kitchen Plumbing' },
  508: { name: 'Leak Detection & Repair' },
  509: { name: 'Pipework Installation' },
  510: { name: 'Radiator Installation & Balancing' },
  511: { name: 'Underfloor Heating' },
  512: { name: 'Unvented Systems' },
};

const AdminPlumbingPricingRules = ({ isTabMode = false }) => (
  <AdminElectricalStylePricingEditor
    services={SERVICES}
    title="Plumbing, Heating & Gas Pricing Rules"
    description="Manage pricing for 13 plumbing and heating services"
  />
);

export default AdminPlumbingPricingRules;
